import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import auth, { authEpic } from "reducers/auth";
import client from "reducers/client";
import leftMenu from "reducers/leftMenu";
import mobileMenu from "reducers/mobileMenu";
import filterMenu from "reducers/filterMenu";
import navHeader from "reducers/navHeader";
import configuration from "reducers/configuration";
import print from "reducers/print"
import { reducer as filters } from "reducers/filters";

export const rootReducer = combineReducers({
  auth,
  client,
  leftMenu,
  mobileMenu,
  filterMenu,
  navHeader,
  filters,
  configuration,
  print
});

export const rootEpic = combineEpics(authEpic);

export type Store = ReturnType<typeof rootReducer>;
